import styled from 'styled-components';
import { green } from 'utils/style/colors';

export const TaskFileBrowseIcon = styled('span')`
  color: var(--exact-white);
  cursor: pointer;
  margin-right: 0.2rem;
  padding: 5px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  border-radius: 100%;
  background-color: ${green};
`;

export const TaskFilePickerWrapper = styled('div')`
  display: inline-flex;
  margin: 0.5rem;
  flex-direction: column;
`;

export const TaskRelatedItems = styled('div')`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.5rem;
`;
